import {Injectable} from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import * as CryptoJS from 'crypto-js';


@Injectable({
    providedIn: 'root',
})
export class CacheService {
    
  public cache$ = new  BehaviorSubject < any []>( null ); 
  private lckey = '#{lckey}#';

  set ( key : string , data : any) { 
    localStorage.removeItem(key);
    const ciphertext = CryptoJS.AES.encrypt(
        JSON.stringify(data),
        this.lckey
    );
    localStorage.setItem(key, ciphertext.toString());
  } 
 
  get ( key : string ): any{ 
    if (localStorage.getItem(key) != null) {
      const bytes = CryptoJS.AES.decrypt(
          localStorage.getItem(key),
          this.lckey
      );
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    }
  } 

  clear ( key : string ): void { 
    if (localStorage.getItem(key) != null) {
      localStorage.removeItem(key);
    }
  } 

}

